import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { useAuth } from '../hooks/useAuth';
import Navbar from './Navbar';
import Footer from './Footer';

export default function ProtectedRoute({ requireAdmin = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="success" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== 'admin') return <Navigate to="/dashboard" replace />;

  return (
    <div className="d-flex flex-column min-vh-100" style={{ background: '#0f0f1a' }}>
      <Navbar />
      <div className="container-fluid py-4 flex-grow-1">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
